import { DocsResource } from '@/business-components/docs-resource/DocsResource';
import { SidebarTree } from '@/business-components/sidebar-tree/SidebarTree';
import { ErrorBoundary } from '@/components/error-boundary/ErrorBoundary';
import { SplitPane } from '@/components/react-split-pane/components/split-pane/SplitPane';
import { useCalcNavbarHeight } from '@/hooks/useCalcNavbarHeight';
import { useCalcNotificationHeight } from '@/hooks/useCalcNotificationHeight';
import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { NavigationTypeEnum } from '@/shared/constant/navigation/Navigation';
import { ScreenSize, SidebarPanelSize } from '@/shared/constant/ScreenSize';
import { ModelType } from '@tarslib/types/lib/common';
import clsx from 'clsx';
import React from 'react';
import { BrandLogoArea } from '../brand-logo-area/BrandLogoArea';

export function ResourcePanel() {
  const isDebugPanelOpen = useAppearanceConfigModelStore((x) => x.isOpenDebugPanel);
  const debugPanelSize = useAppearanceConfigModelStore((x) => x.debugPanelSize);
  const screenSize = useAppearanceConfigModelStore((x) => x.screenSize);
  const navigationType = useDocsDataModelStore((x) => x.navigation.type);
  const navbarHeight = useCalcNavbarHeight();
  const notificationHeight = useCalcNotificationHeight();
  const resourceType = useDocsDataModelStore((x) => x.resourceData.type);

  const paddingRight = React.useMemo(() => {
    if (
      !isDebugPanelOpen ||
      screenSize === ScreenSize.Mobile ||
      screenSize === ScreenSize.OnlySidebar ||
      resourceType !== ModelType.HttpApi
    ) {
      return undefined;
    }

    return debugPanelSize;
  }, [debugPanelSize, isDebugPanelOpen, screenSize, resourceType]);

  return (
    <SplitPane
      defaultSize={SidebarPanelSize.defaultSize}
      minSize={SidebarPanelSize.minSize}
      maxSize={SidebarPanelSize.maxSize}
      resizerClassName={clsx('hidden os:flex')}
      resizerLineClassName={clsx('hover:bg-border-color-base', {
        ['bg-border-color-base']: navigationType === NavigationTypeEnum.None,
      })}
      className={clsx('_resource-panel mx-auto w-full', {
        ['max-w-[1560px]']: !isDebugPanelOpen,
        ['max-w-[1800px]']: isDebugPanelOpen,
      })}
      pane1ClassName={clsx('sticky hidden os:flex', {
        ['as:hidden tc:flex']: isDebugPanelOpen,
      })}
      pane1Style={{
        top: navbarHeight,
        height: `calc(100vh - ${navbarHeight + notificationHeight}px)`,
      }}
    >
      <div className="flex w-full flex-col overflow-y-auto">
        {navigationType === NavigationTypeEnum.None && <BrandLogoArea className="p-5 pb-2.5" />}

        <SidebarTree />
      </div>
      <div className="w-full px-5 pt-5 os:pl-10">
        <div
          style={{
            paddingRight,
          }}
        >
          <ErrorBoundary>
            <DocsResource />
          </ErrorBoundary>
        </div>
      </div>
    </SplitPane>
  );
}
